import { render, staticRenderFns } from "./AddWorkDetailPage.vue?vue&type=template&id=5eac53e4&"
import script from "./AddWorkDetailPage.vue?vue&type=script&lang=js&"
export * from "./AddWorkDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports